import styles from './TeaserHighlight.module.scss'
import React from 'react'
import { AreaItem } from '@/types/cms/AreaItem'
import { Link } from '@/components/Link'
import { Image } from '@/components/Image'
import TypeVisualizer from '@/elements/widgets/Teaser/components/TypeVisualizer/TypeVisualizer'
import LiveLabel from '@/elements/widgets/Teaser/components/LiveLabel/LiveLabel'
import { clsx } from 'clsx'

const TeaserHighlight = ({ item, children, options }: { item: AreaItem; children: React.ReactNode; options: any }) => {
  const teaser = item
  if (!teaser) {
    return null
  }

  return (
    <article
      className={clsx(styles.teaser, options?.mobile && styles.mobile)}
      title={teaser.model.headline ?? teaser.model.title}
    >
      <Link
        href={
          teaser.model.type === 'teaserexternal' && teaser.model.linkExternal
            ? teaser.model.linkExternal?.url
            : teaser.model.url
        }
        target={
          teaser.model.type === 'teaserexternal' && teaser.model.linkExternal
            ? teaser.model.linkExternal?.target
            : '_self'
        }
        className={styles.link}
      >
        <div className={styles.container}>
          <Image
            priority={true}
            image={teaser.model.image}
            alt={teaser.model.image?.filename || teaser.model.title}
            className={styles.image}
          />
          <LiveLabel url={teaser?.model?.linkExternal?.url} position="top-left" className={styles['live-label']} />
          <TypeVisualizer item={teaser} position="top-left" className={styles['type-visualizer']} />
          {children}
        </div>
        {teaser.model.leadtext && !options?.hideLeadText && (
          <div className={styles['lead-text']} data-cy="lead-text">
            {teaser.model.leadtext}
          </div>
        )}
      </Link>
    </article>
  )
}

export default TeaserHighlight
